export default `<div style="font-size:16px;font-weight:bold;padding-bottom:10px;">《亮健康隐私政策》2021年9月30日生效版本
</div>尊敬的亮健康用户：我们对《亮健康隐私政策》进行了更新。此版本《亮健康隐私政策》的更新主要集中在：<span style="font-weight:bold;">亮健康需要收集的个人信息种类、申请权限信息。</span> 您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴于此，亮健康平台服务提供者（或简称“我们”）制定本《隐私权政策》（下称“本隐私权政策”）并提醒您：  本政策适用于亮健康平台提供的所有产品和服务。如我们及关联公司（范围详见定义部分）的产品或服务中使用了亮健康平台提供的产品或服务（例如使用亮健康平台账户登录）但未设独立隐私权政策的，则本政策同样适用于该部分产品或服务。我们及关联公司就其向您提供的产品或服务单独设立有隐私权政策的，需要特别说明的是，本政策不适用于其他第三方向您提供的服务，第三方向您提供的服务适用其向您另行说明的隐私权政策。  在使用亮健康平台各项产品或服务前，请您务必仔细阅读并透彻理解本政策，特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。如对本政策内容有任何疑问、意见或建议，您可通过亮健康提供的各种联系方式与我们联系。 

版本更新日期：2021年【9】月【30】日

版本生效日期：2021年【9】月【30】日

    定义： 亮健康：指亮健康客户端。  亮健康服务提供者：湖南亮健优医易问网络科技有限公司  个人信息： 指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。  个人敏感信息：指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童信息等的个人信息（我们将在本隐私权政策中对具体个人敏感信息以粗体进行显著标识）。  个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。  儿童：指不满十四周岁的未成年人。  除另有约定外，本政策所用定义与《亮健康平台服务协议》中的定义具有相同的涵义。  

本隐私政策将帮助您了解以下内容：

<span style="font-weight:bold;color:#333;">一、我们如何收集和使用您的信息</span> 

<span style="font-weight:bold;color:#333;">二、我们如何使用Cookie和同类技术</span> 

<span style="font-weight:bold;color:#333;">三、我们如何共享、转让、公开披露您的信息</span> 

<span style="font-weight:bold;color:#333;">四、我们如何保护您的信息</span> 

<span style="font-weight:bold;color:#333;">五、您如何管理您的信息</span> 

<span style="font-weight:bold;color:#333;">六、我们如何处理未成年人的信息</span> 

<span style="font-weight:bold;color:#333;">七、您的信息如何在全球范围转移</span> 

<span style="font-weight:bold;color:#333;">八、本隐私权政策如何更新</span> 

<span style="font-weight:bold;color:#333;">九、如何联系我们</span> 
 
一、我们如何收集和使用您的信息 在您使用我们的产品及/或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：

1、为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；

2、为实现向您提供我们产品及/或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基本功能。  您理解并同意： 

1、我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品/服务范围存在差异，相应的，基本/附加功能及收集使用的个人信息类型、范围等会有所区别，请以具体的产品/服务功能为准；

2、为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本政策、弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。在此过程中，如果您有任何疑问、意见或建议的，您可通过亮健康平台提供的各种联系方式与我们联系，我们会尽快为您作出解答。  我们会为实现本政策下述的各项功能，收集和使用您的个人信息：  

（一）帮助您成为我们的会员

 1、基础会员服务 我们通过亮健康平台账户为您提供基础会员服务。为注册成为会员并使用我们的会员服务，您需要提供手机号码、拟使用的会员名和密码用于创建亮健康平台账户。如果您仅需使用浏览、搜索服务，您不需要注册成为我们的会员及提供上述信息。  对于需要通过亮健康平台账户才能使用的服务，我们可能会根据您提供的上述信息校验您的会员身份，确保我们是在为您本人提供服务。若存在依法需确定您会员身份的场景（包括依法为您扣缴税费、行政执法或司法诉讼中相关主体认定等）时，您授权我们可自支付公司处获取您对应支付账户的相关认证信息用于上述目的。  我们会根据您的会员账户使用情况及平台设置的会员等级计算规则确定您当前的会员等级，并为您提供相应会员等级所对应的基本权益。  

2、附加会员服务 特别会员权益：如果您选择提供<span style="font-weight:bold;color:#333;">真实姓名、性别、出生年月日、居住地、昵称、头像</span>等非注册必须的个人资料，我们可以为您提供会员生日特权等更加个性化的会员服务。其中，为保证交易辨识度，您的昵称、头像将公开显示。  授权登录：我们可能经您同意后向第三方共享您的账户信息（头像、昵称及其他页面提示的信息），使您可以便捷地实现第三方账户的注册或登录。此外，我们可能会根据您的授权从第三方处获取您的第三方账户信息，并与您的亮健康平台账户进行绑定，使您可通过第三方账户直接登录、使用我们的产品及/或服务。我们将在您授权同意的范围内使用您的相关信息。  其他会员角色服务：如果您申请注册成为卖家、服务商或其他存在额外身份认证要求的会员角色，您需主动向我们提供<span style="font-weight:bold;color:#333;">身份信息及/或企业相关信息，或授权我们自支付公司处获取您对应支付账户的上述相关认证信息</span>，用于您身份及特殊会员角色获取资格的核验、登记、公示及其他我们明确告知的目的。  

3、账户信息展示：如果您已拥有亮健康平台账户，我们可能会在亮健康平台服务中显示您的上述个人信息（实人认证仅显示认证是否通过的结果），以及您在亮健康平台上或与亮健康平台账户相关联的产品和服务中执行的操作（您可通过亮健康平台账户在我们提供的亮健康/手机亮健康首页、“必备工具”、“添加卡片”链接入口或其他产品/服务入口使用我们及/或关联公司提供的产品或服务），包括通过亮健康平台账户集中展示您的个人资料、优惠权益、交易订单。我们会尊重您对亮健康平台服务和亮健康平台账户设置所做的选择。  

（二）为您提供商品或服务信息展示 在您使用我们服务过程中，为识别账号异常状态、了解产品适配性、向您提供更契合您需求的页面展示和搜索结果，我们可能会自动收集您的使用情况并存储为网络日志信息，包括：  <span style="font-weight:bold;color:#333;">设备信息：我们会根据您在软件安装及/或使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、唯一设备标识符、设备环境、移动应用列表、BSSID等软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）</span>。  服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、点击查看、搜索查询、收藏、添加至购物车、交易、售后、关注分享信息、发布信息，以及IP地址、浏览器类型、电信运营商、使用语言、访问日期和时间。  请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。  为向您提供更便捷、更符合您个性化需求的信息展示、搜索及推送服务，我们会根据您的设备信息和您使用亮健康的网站或客户端时的浏览使用信息，提取您的偏好特征，并基于特征标签产出间接人群画像，用于展示、推送信息和可能的商业广告。  我们努力保障您的浏览体验。如果您不想接受我们给您发送的商业广告，您可通过短信提示回复退订或我们提供的其他方式进行退订或关闭。在您使用我们提供的站内搜索服务时，我们也同时提供了不针对您个人特征的通用排序选项（您可以在搜索结果页面点击“筛选”/“更多”，选择其中的“通用排序”进行设置）。为尽可能地减少与您无关的信息对您造成的打扰，我们一直在改进和优化内容推荐机制。在您打开我们网站或客户端首页或进入支付完成页面时，您可以通过长按商品或服务的图片后根据提示实现对我们展示的商品或服务内容的管理操作，如选择屏蔽对应商品或服务，或直接选择屏蔽商品或服务所属的偏好品类。  此外，我们也会为了不断改进和优化上述的功能来使用您的上述信息。 

（三）为您提供收藏、加购、关注与分享功能 在您浏览我们网站或客户端的过程中，您可以选择对感兴趣的商品及/或服务进行收藏、添加至购物车、与您感兴趣的商家/品牌/其他会员建立关注关系、通过我们提供的功能组件向其他第三方分享信息。在您使用上述功能的过程中，我们会收集包括您的<span style="font-weight:bold;color:#333;">收藏及添加购物车的记录、关注关系、分享历史在内的服务日志信息</span>用于实现上述功能及其他我们明确告知的目的。

（四）帮助您完成下单及订单管理 当您在我们的产品及/或服务中订购具体商品及/或服务时，我们会通过系统为您生成购买该商品及/或服务的订单。在下单过程中,您需至少提供您的收货人姓名、收货地址、收货人联系电话，同时该订单中会载明您所购买的商品及/或服务信息、具体订单号、订单创建时间、您应支付的金额，我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、查询订单信息、提供客服与售后服务及其他我们明确告知的目的。  您可以通过亮健康平台为其他人订购商品及/或服务，您需要提供该实际订购人的前述个人信息，若其中涉及儿童个人信息的，您需在提供前征得对应儿童监护人的同意。  为便于您了解查询订单信息并对订单信息进行管理，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。  您可额外填写/选择包括其他联系电话、收货时间在内的更多附加信息以确保商品或服务的准确送达。  

（五）帮助您完成支付 为完成订单支付，您需要提供支付账户并选择付款方式，我们会将您的亮健康平台账户会员名、对应的支付账户会员名、订单支付相关信息、订单安全相关设备信息及其他反洗钱法律要求的必要信息通过在应用程序中嵌入的支付软件工具开发包（软件工具开发包在本政策中简称“SDK”）等方式与支付公司共享。如您选择由其他金融机构为您提供支付服务的，我们还会将您的包括银行卡号、有效期在内的银行卡支付必要信息与您选择的相应金融机构共享。  您可以请求其他人为您付款，那么您需要提供代付人的支付账户及/或手机号码。  为使我们及时获悉并确认您的支付进度及状态，为您提供售后与争议解决服务，您同意我们可自您所选择的交易对象、支付公司或您选择的其他金融机构处收集与支付进度相关信息。  

（六）帮助向您完成商品或服务的交付 为保证您购买的商品及/或服务能够顺利、安全、准确送达，我们会向为亮健康平台提供物流信息系统和技术服务的供应链管理有限公司披露订单相关配送信息，并由其根据商品及/或服务提供主体的指定向相应的物流配送主体同步相关配送信息。您知晓并同意相应物流配送主体不可避免地获知及使用您的配送信息，用于完成交付目的。  为使我们及时获悉并确认交付进度及状态，向您提供售后与争议解决服务，您同意我们可自物流相关服务主体处收集与交付进度相关信息。  

（七）客服及争议处理 当您与我们联系或提出售中售后、争议纠纷处理申请时，为了保障您的账户及系统安全，我们需要您提供必要的个人信息以核验您的会员身份。  为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的通信/通话记录及相关内容（包括账号信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息），如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的账号信息和订单信息。  为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。 

 （八）为您提供评论、问答等信息公开发布功能 您可通过我们为您提供的评论、问答、论坛、晒单分享、直播及其他信息发布功能公开发布信息，包括作为会员可发布图文/视频/直播内容、发表评价及问答内容、或服务相关信息、店铺相关信息  请注意，您公开发布的信息中可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。若您公开发布的信息中涉及儿童个人信息的，您需在发布前征得对应儿童监护人的同意。  

（九）为您提供安全保障 为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或亮健康平台相关协议规则的情况，我们在应用程序中嵌入我们关联公司开发的应用安全SDK收集您的设备信息、服务日志信息，并可能使用或整合您的会员信息、交易信息、设备信息、服务日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。

（十）为您提供其他附加服务 为向您提供更便捷、更优质、个性化的产品及/或服务，努力提升您的体验，我们在向您提供的以下附加服务中可能会收集和使用您的个人信息。如果您不提供这些信息，不会影响您使用亮健康的浏览、搜索、购买等基本服务，但您可能无法获得这些附加服务给您带来的用户体验。这些附加服务包括： 

 1、基于位置信息的个性化推荐服务：我们会在您开启位置权限后访问获取您的位置信息，根据您的位置信息为您提供更契合您需求的页面展示、产品及/或服务，比如向您推荐附近的优惠信息。 

2、基于相机/摄像头的附加服务：您可在开启<span style="font-weight:bold;color:#333;">相机/摄像头权限</span>后使用该功能进行扫码用于登录、购物、领取优惠信息，拍摄照片或视频用于评价、分享，以及特定场景下经您授权的人脸识别等功能。当您使用该附加功能进行人脸识别时我们会收集您的面部特征，且严格在经您授权同意的范围内使用，未来如我们拟使用您的面部信息为您提供其他产品及/或服务功能的，我们会再次与您确认。请您知晓，即使您已同意开启相机权限，我们也仅会在您主动点击客户端内相机图标或录制视频时通过相机获取照片信息。  

3、基于相册（图片库/视频库）的图片/视频访问及上传的附加服务：您可在开启相册权限后使用该功能上传您的照片/图片/视频，以实现更换头像、发表评论/分享、拍照购物或与客服沟通提供证明等功能。我们可能会通过您所上传的照片/图片来识别您需要购买的商品或服务，或使用包含您所上传照片或图片的评论信息。为实现您的好友、活动优惠等链接分享需求，我们可能会在设备本地读取您最近一次主动保存的图片链接地址。 

 4、基于麦克风的语音技术相关附加服务：您可在开启麦克风权限后使用麦克风实现语音购物功能，或与客服联系或与客服机器人实现语音交互，在这些功能中我们会收集您的录音内容以识别您的购物需求，或响应您的客服及争议处理等需求。请您知晓，即使您已同意开启麦克风权限，我们也仅会在您主动点击客户端内麦克风图标或录制视频时通过麦克风获取语音信息。 

 5、基于电话状态的附加服务：为保障您的账号与使用安全，您需要授权我们读取本机识别码。 您理解并同意，上述附加服务可能需要您在您的设备中开启您的<span style="font-weight:bold;color:#333;">位置信息（地理位置）、摄像头（相机）、相册（图片库）、麦克风（语音）、通讯录、日历及/或电话状态</span>的访问权限，以实现这些权限所涉及信息的收集和使用。您可在您的设备设置或我们客户端“我的亮健康-设置-隐私—系统权限”中逐项查看上述权限的状态，并可自行决定这些权限随时的开启或关闭。 请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。

6、实现网上购物所必须的功能

（1）账户注册、登录与验证

当您注册亮健康账户时，您至少需要向我们提供您准备使用的亮健康账户名、密码、您本人的手机号码、，我们将通过发送短信验证码的方式来验证您的身份是否有效。您的账户名为您的默认昵称，您可以修改和补充您的昵称、性别、年龄、地区这些信息均属于您的“账户信息”。您补充的账户信息将有助于我们为您提供个性化的商品推荐和更优的购物体验，但如果您不提供这些补充信息，不会影响您使用亮健康app的基本功能。

当您成功注册亮健康账号后，可以使用亮健康账号登录“亮健康app”，登录时您需要向我们提供您的亮健康账号信息。若您不提供这类信息，您将无法登录和在“亮健康app”购买商品，此时您可使用浏览和搜索功能，我们将不会收集您的上述个人信息。

（2）商品/服务信息展示和搜索

为了让您快速地找到您所需要的商品，我们可能会收集您使用我们的产品与/或服务的<span style="font-weight:bold;color:#333;">设备信息（包括设备名称、设备型号、MAC地址及IMEI、设备识别码、移动应用列表等软硬件特征信息、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络ID（PLMN）、BSSID）、设备所在位置相关信息（包括您授权的GPS位置信息以及WLAN接入点、蓝牙和基站传感器信息）、浏览器类型</span>来为您提供商品信息展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息。如果您不想看到推荐的商品或服务等信息，您可以通过长按被推荐的商品或服务图片，根据提示弹窗选择屏蔽相关商品或服务类目。

您也可以通过搜索来精准地找到您所需要的商品或服务。我们会保留您的搜索内容以方便您重复输入或为您展示与您搜索内容相关联的商品或服务。
请您注意，单独的设备信息、浏览器类型或仅搜索关键词信息无法单独识别您的身份，不属于您的个人信息，我们有权以任何的目的对其进行使用；只有当您的单独的设备信息、浏览器类型或搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时，则在结合使用期间，我们会将您的设备信息、浏览器类型或搜索关键词信息作为您的个人信息，按照本隐私政策对其进行处理与保护。

为了将您感兴趣的商品或服务信息展示给您，或在您搜索时向您展示您可能希望找到的商品，我们可能会收集您的订单信息、浏览信息、您的兴趣爱好（您可以在账户设置中选择）进行数据分析以形成用户画像。我们还可能为了提供服务及改进服务质量的合理需要而获得的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、个性化内容和建议。如果您不希望受个性化内容的影响，您可以在商品展示页选择按照分类进行浏览和查找商品和服务；我们还在搜索结果中向您提供了按照价格、销量排序等不针对个人特征的选项；未经您的明确同意，我们不会将您的相关个人信息提供给第三方。

（3）下单及订单管理

当您准备对您购物车内的商品进行结算时，亮健康系统会生成您购买该商品的订单。您需要在订单中至少填写您的收货人姓名、收货地址以及手机号码，同时该订单中会载明订单号、您所购买的商品或服务信息、下单时间、您应支付的货款金额及支付方式；您可以另外填写收货人的联系电话、邮箱地址信息以增加更多的联系方式确保商品可以准确送达，但不填写这些信息不影响您订单的生成。若您需要开具发票，还需要提供发票抬头、纳税人识别号以及接收发票电子邮箱。

在实现部分特殊类型商品交易或服务时还需要您提供其他必要信息，例如您在亮健康上购买处方药的要求提供您的实名信息，这些实名信息可能包括您的身份信息（比如您的出生证明、户口本、身份证、军官证、护照、驾驶证等载明您身份信息的证件复印件或号码）、您本人的照片或视频、姓名、电话号码。

上述所有信息构成您的“订单信息”，我们将使用您的订单信息来（包括与为您提供上述服务的第三方）进行您的身份核验、确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务。我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。

（4）支付功能

在您下单后，您可以选择亮健康的关联方或与亮健康合作的第三方支付机构（支付宝支付、微信支付）所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的亮健康订单号与交易金额信息与这些支付机构共享以实现其确认您的支付指令并完成支付。“关联方”指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的法定代表人。“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。

（5）交付产品与/或服务功能

在当您下单并选择货到付款或在线完成支付，亮健康、亮健康的关联方、供应商、与亮健康合作的商家或第三方配送公司（以下称“配送公司”）将为您完成订单的交付。您知晓并同意，亮健康、亮健康的关联方、供应商、与亮健康合作的商家或配送公司会在上述环节内使用您的订单信息以保证您的订购的商品能够安全送达。

（6）客服与售后功能

我们的电话客服和售后功能会使用您的账号信息和订单信息。

为保证您的账号安全，我们的呼叫中心客服和在线客服会使用您的账号信息与您核验您的身份。当您需要我们提供与您订单信息相关的客服与售后服务时，我们将会查询您的订单信息。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息，如当您要求我们变更配送地址、联系人或联系电话。

若您有获赠或购买商品运费险，您在退换货时所产生的运费可能申请由运费险服务提供商进行赔付，为实现投保和理赔，我们将收集或查询您购买商品的质保起止期、退换货商品快递公司、快递单号、退货地址、投递时间信息。

7、保障交易安全所必须的功能

为保障您使用我们的产品与/或服务时系统的稳定性和安全性，防止您的个人信息被非法获取，更准确地预防欺诈和保护账号安全，我们需要收集您的<span style="font-weight:bold;color:#333;">设备信息（设备型号、设备Mac地址、应用进程列表、设备识别码、操作系统及软件版本、设备状态、网络状况、BSSID）、历史上网记录、日志信息、面部信息、IP地址、位置信息、浏览信息、订单信息、常用软件列表、ssid、wifi信息、电池使用情况</span>来判断您的账号风险，并可能会记录一些我们认为有风险的链接（“URL”）；我们也会收集您的设备信息用于对亮健康系统问题进行分析、统计流量并排查可能存在的风险，在您选择向我们发送异常信息时予以排查。如果您不提供上述信息，我们则无法在您使用亮健康服务过程中对您的服务及账号安全进行保护。

8、您可自主选择提供的个人信息的情形

为使您购物更便捷或更有乐趣，从而提升您在亮健康的网上购物体验，我们的以下扩展功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以进行网上购物，但您可能无法使用为您带来购物乐趣的扩展功能或在购买某些商品时需要重复填写一些信息。这些扩展功能包括：

（1）基于位置信息的个性化推荐功能（LOCATION）：我们会收集您的位置信息（我们仅收集您当时所处的地理位置，但不会将您各时段的位置信息进行结合以判断您的行踪轨迹）来判断您所处的地点，自动为您推荐您所在区域可以购买的产品与/或服务，例如向您推荐离您最近的诊室。

（2）基于<span style="font-weight:bold;color:#333;">摄像头（相机）的扩展功能（CAMERA）</span>：您可以使用这项扩展功能完成视频拍摄、拍照、扫码以及人脸识别登录的功能。当您使用人脸识别登录时我们会收集您的面部信息，且在您授权范围内限制使用。未来我们可能会将人脸识别技术应用于更多场景，届时我们会再次与您确认您是否愿意我们使用您的面部信息来实现这些扩展功能。

（3）基于图片/视频上传的扩展功能：您可以在亮健康上传您的照片/视频来实现拍照购物功能和晒单、评价，我们会使用您所上传的图片或视频来识别您需要购买的产品与/或服务，或者使用包含您所上传图片或视频的晒单、评价及问答内容。

（4）基于日历权限的扩展功能（READ_CALENDAR）：当您使用亮健康相关服务时，您可以通过开启日历权限便捷管理您的自定义事项、设定重要事项提醒。若您不开启此权限，您将无法使用日历管理相关的功能，但不影响您使用其他服务。

（5）基于读取<span style="font-weight:bold;color:#333;">电话状态的扩展功能(READ_PHONE_STATE)</span>：当您运行亮健康APP时，我们会向您申请获取此权限，目的是正常识别您的本机识别码，以便完成安全风控、进行统计和服务推送。

（6）基于<span style="font-weight:bold;color:#333;">读取/写入外置存储器的扩展功能(WRITE_EXTERNAL_STORAGE)( READ_EXTERNAL_STORAGE)</span>：在您开启我们可读取/写入您设备存储的权限后，我们将自您设备存储空间内读取或向其中写入图片、文件、崩溃日志信息等必要信息，用于向您提供信息发布或在本地记录崩溃日志信息等功能，保障客户端的稳定运行。

（7）基于剪切板的扩展功能：当您复制商品信息、标题、短信验证码，分享或接收被分享信息时，您的剪切板功能可能会被调用。剪切板信息仅会在您的设备上进行处理，我们不会存储您的剪切板信息用于任何其他途径。

 (8)获取运行中进程信息

9、上述扩展功能可能需要您在您的设备中向我们开启您的地理位置（位置信息）、相机（摄像头）、相册（图片库）、日历、通讯录、电话状态、外部存储、软件安装列表，以实现这些功能所涉及的信息的收集和使用。您可以在亮健康APP或设备系统中逐项查看您上述权限的开启状态，并可以决定将这些权限随时的开启或关闭（我们会指引您在您的设备系统中完成设置）。请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。除此以外，我们在相关业务功能中可能还需要您开启设备的其他访问权限，详细权限和使用目的如下：

<span style="font-weight:bold;">
（1）android.permission.INTERNET（访问网络权限）：实现应用程序联网

（2）android.permission.ACCESS_WIFI_STATE（获取WiFi状态权限）：监控网络变化，提示用户当前网络环境

（3）android.permission.ACCESS_NETWORK_STATE（获取网络状态权限）：监控网络变化，提示用户当前网络环境

（4）android.permission.VIBRATE（使用振动权限）：允许手机振动

（5）android.permission.WAKE_LOCK（唤醒锁定权限）：允许程序在手机屏幕关闭后后台进程仍然运行，保持屏幕唤醒

（6）android.permission.RESTART_PACKAGES（结束系统任务权限）：重新启动应用

（7）android.permission.MODIFY_AUDIO_SETTINGS（修改声音设置权限）：修改全局音频设置，例如调节音量和用于输出的扬声器

（8）android.permission.SYSTEM_ALERT_WINDOW（悬浮窗权限）：观看直播、短视频悬浮窗播放

（9）android.permission.ACCESS_BACKGROUND_LOCATION（支持后台访问位置权限）：保持持续定位能力

（10）android.permission.WRITESYSTEM（读写系统设置权限）：允许应用读写系统设置项

（11）android.permission.GET_TASKS（获取软件安装列表,获取运行中进程信息）：允许应用获取软件安装列表,与第三方APP(如微信)分享交互行为

（12）android.permission.CHANGE_WIFI_STATE（改变WiFi状态权限）：允许应用改变WiFi状态

（13）android.permission.BLUETOOTH,android.permission.BLUETOOTH,android.permission.BLUETOOTH_ADMIN(蓝牙权限)：开启蓝牙,用于连接血糖仪和血压计测量

（14）android.permission.ACCESS_FINE_LOCATION(定位权限)：获取当前定位权限,配合蓝牙使用

（15）android.permission.WRITE_EXTERNAL_STORAGE(写入外部存储权限)：允许应用存储数据
</span>

<span style="font-weight:bold;">（16）第三方 SDK 详情</span>

<span style="font-weight:bold;">1.SDK名 称：移动推送 TPNS SDK</span>
第三方名称：深圳市腾讯计算机系统有限公司
SDK 用途：在移动终端设备进行消息推送
收集个人信息类型：设备信息(手机型号，系统类型、系统版本等)用于标签化推送以及识别是否是真机、网络信息(网络类型)支持根据不同网络类型进行不同类型推送、账号绑定信息(根据您所选用的不同推送渠道，QQ号、微信Union ID、 手机号、邮箱等)用于根据账号信息进行推送。
数据处理方式：通过去标识化、加密传输及其他安全方式
官网链接：<a href="https://cloud.tencent.com/product/tpns" style="color:#333">https://cloud.tencent.com/product/tpns</a>
隐私政策链接：<a href="https://privacy.qq.com/document/preview/8565a4a2d26e480187ed86b0cc81d727" style="color:#333">https://privacy.qq.com/document/preview/8565a4a2d26e480187ed86b0cc81d727</a>

<table border="1" style="border-collapse: collapse;width: 100%;word-break: break-all;  word-wrap:break-word;">
  <tr style="background:#f5f7fa;">
    <th style="padding:6px">第三方 SDK 名称</th>
    <th style="padding:6px">SDK 用途</th>
    <th style="padding:6px">隐私政策链接</th>
    <th style="padding:6px">收集个人信息类型</th>
  </tr>
  <tr>
    <td style="padding:6px">小米推送 SDK</td>
    <td style="padding:6px">对小米品牌手机消息推送</td>
    <td style="padding:6px"><a href="https://privacy.mi.com/all/zh_CN/" style="color:#333">https://privacy.mi.com/all/zh_CN/</a></td>
    <td style="padding:6px">网络状态信息、设备信息、存储信息</td>
  </tr>
  <tr>
    <td style="padding:6px">华为推送 SDK</td>
    <td style="padding:6px">对华为品牌手机消息推送</td>
    <td style="padding:6px"><a href="https://www.huawei.com/cn/privacy-policy" style="color:#333">https://www.huawei.com/cn/privacy-policy</a></td>
    <td style="padding:6px">网络状态信息、设备信息、存储信息、位置信息</td>
  </tr>
  <tr>
    <td style="padding:6px">OPPO 推送 SDK</td>
    <td style="padding:6px">对 OPPO 品牌手机消息推送</td>
    <td style="padding:6px"><a href="https://www.oppo.com/cn/support/service-policy/privacy/#" style="color:#333">https://www.oppo.com/cn/support/service-policy/privacy/#</a></td>
    <td>设备信息</td>
  </tr>
  <tr>
    <td style="padding:6px">vivo 推送 SDK</td>
    <td style="padding:6px">对 vivo 品牌手机消息推送</td>
    <td style="padding:6px"><a href="https://www.vivo.com.cn/about-vivo/privacy-policy" style="color:#333">https://www.vivo.com.cn/about-vivo/privacy-policy</a></td>
    <td style="padding:6px">设备信息</td>
  </tr>
  <tr>
    <td style="padding:6px">魅族推送 SDK</td>
    <td style="padding:6px">对魅族品牌手机消息推送</td>
    <td style="padding:6px"><a href="https://i.flyme.cn/privacy?lang=zh_CN" style="color:#333">https://i.flyme.cn/privacy?lang=zh_CN</a></td>
    <td style="padding:6px">设备信息</td>
  </tr>
  <tr>
    <td style="padding:6px">FCM SDK</td>
    <td style="padding:6px">对 Google 原生系统手机消息推送</td>
    <td style="padding:6px"><a href="https://firebase.google.com/support/privacy" style="color:#333">https://firebase.google.com/support/privacy</a></td>
    <td style="padding:6px">设备信息</td>
  </tr>
  <tr>
    <td style="padding:6px">APNs SDK</td>
    <td style="padding:6px">对苹果品牌手机消息推送</td>
    <td style="padding:6px"><a href="https://www.apple.com/legal/privacy/en-ww/" style="color:#333">https://www.apple.com/legal/privacy/en-ww/</a></td>
    <td style="padding:6px">设备信息</td>
  </tr>
</table>


<span style="font-weight:bold;">2.GIO移动端 SDK(GrowingIO SDK)</span>
用途：分析收集移动应用程序(App)用户的使用情况
收集个人信息类型：设备标识信息（如IMEI、Android ID、OAID），粘贴板内容，设备类型，设备版本，系统版本，地理位置信息，网络设备制造商，IP地址，网络模式、获取运行中进程信息、获取Android_ID、获取粘贴板信息
提供方：北京易数科技有限公司 
第三方SDK隐私协议链接： <a href="https://accounts.growingio.com/user-privacy" style="color:#333">https://accounts.growingio.com/user-privacy</a>


<span style="font-weight:bold;">3.openinstall SDK(io.openinstall)</span>
用途: 携带参数安装，H5渠道统计，应用统计，一键跳转
收集个人信息类型：SDK版本、应用程序版本、应用程序包名、IP地址（用于地理位置定位）、设备型号、硬件序列号、终端制造产商、终端设备操作系统版本、获取Android_ID 获取粘贴板信息 获取MAC地址 获取运行中进程信息
提供方:深圳市分秒网络科技有限公司
第三方SDK隐私协议链接： <a href="https://www.openinstall.io/yinsi.html" style="color:#333">https://www.openinstall.io/yinsi.html</a>



<span style="font-weight:bold;">4.移动一键登录SDK</span>
用途:根据用户选择，电话号码一键登录功能
收集个人信息:1.系统运营商信息； 2.iOS广告标识符（IDFA）、MAC地址、国际移动设备识别码（IMEI）、匿名设备标识符(OAID)、国际移动用户识别码（IMSI）； 3.应用列表； 4.基站信息； 5.地理位置信息 6.SIM卡信息。
提供方:中国移动
第三方SDK隐私协议链接: <a href="https://wap.cmpassport.com/resources/html/contract2.html" style="color:#333">https://wap.cmpassport.com/resources/html/contract2.html</a>


<span style="font-weight:bold;">5.个验SDK和个推消息推送SDK</span>
用途:为App用户提供消息推送技术服务和提现风控
（1）设备信息：设备识别码（详见“隐私政策”）、设备平台、设备厂商用于生成唯一的推送目标ID（CID）和设备ID（GID），以此保证消息推送的准确下发和消息设备的准确识别。设备品牌、设备型号及系统版本用于优化通道资源的有效性，提升消息推送的到达率和稳定性。此外，为确保CID的唯一性、提升消息推送稳定性和准确性，还需您授权存储权限（WRITE_EXTERNAL_STORAGE）和设备权限（READ_PHONE_STATE）。
（2）应用列表信息：我们采用合并链路技术进行技术推送，当一个设备有多个APP的推送链路同时活跃时，我们会随机合并成一条链路，以达到为用户省电省流量的目的，因此需获得应用列表信息；同时我们提供智能推送功能，通过该信息推荐更符合您用户需要的推送内容，减少无用推送信息对您用户的打扰，您可以选择开启或关闭这项服务，但是关闭这项服务会导致电量和流量消耗加大。
（3）网络信息以及位置相关信息：为了最大程度保持网络连接的稳定性，建立长链接，我们需要了解设备的网络状态和变化，从而实现稳定连续的推送服务。我们提供应景推送功能，位置相关信息将有助于我们为您提供线下场景的精细化推送，可以为您推荐更符合您用户需要的推送内容，减少无用推送消息对您用户的打扰。
（4）为了保障您收到消息的及时性，在您使用消息推送服务时，您可以授权我们进行链路调节，相互促活被关闭的SDK推送进程，从而保障推送消息的有效触达。
为保障我们推送服务的稳定运行、功能实现，使您能够使用和享受更多的功能及服务，我们的服务中会接入由合作方提供的软件开发工具包（SDK）、应用程序接口（API）[1] 。我们会对合作方获取信息的软件开发工具包（SDK）、应用程序接口（API）[2] 进行严格的安全检测，并与合作方约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。我们接入合作方详情如下，我们建议您阅读相关的隐私政策：
 (5)获取IMSI、运行中进程信息、MAC地址、Android_ID、SIM序列号、获取MAC地址
SDK名称：卓信ID
涉及信息：设备弱特征（不具备唯一性和稳定性的特征）:设备信息(设备制造商、设备型号、设备系统信息)、设备网络信息(设备联网方式和状态信息)、设备环境信息(屏幕亮度、电池状态及所在国家、设备应用信息（设备常见应用的版本等安装信息）
使用目的：提供设备标识与安全风控服务
合作方主体：中国信息通信研究院
收集方式：SDK收集
合作方官网链接：https://zxid.caict.ac.cn
合作方隐私政策链接：https://zxid.caict.ac.cn/privacy

第三方SDK隐私协议链接: <a href="https://docs.getui.com/privacy/">https://docs.getui.com/privacy/</a>

<span style="font-weight:bold;">6.bugly SDK(腾讯Bugly)</span>
收集个人信息:Crash环境：Crash信息及线程堆栈，ROM/RAM/SD卡容量、网络/语言等状态 App信息：包名、版本、所属进程名 设备信息：获取SIM序列号、Android_ID 、SIM卡序列号(ICCID)
使用目的:为用户提供数据统计及崩溃问题收集功能
第三方SDK隐私协议链接:<a href="https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf" style="color:#333">https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf</a>

<span style="font-weight:bold;">7.微信支付SDK</span>
信息获取：唯一设备标识符、MAC地址
使用目的：支持微信登录，帮助用户分享内容至第三方应用并提供微信支付功能
隐私协议地址：<a href="https://open.weixin.qq.com">https://open.weixin.qq.com</a>

<span style="font-weight:bold;">8.Alipay（支付宝）SDK-支付宝（杭州）信息技术有限公司</span>
用途:购买商品
收集个人信息类型：唯一设备标识符、MAC地址
第三方SDK隐私协议链接: <a href="https://opendocs.alipay.com/open/54/01g6qm" style="color:#333">https://opendocs.alipay.com/open/54/01g6qm</a>

<span style="font-weight:bold;">9.腾讯云IM SDK</span>
信息获取：设备信息（设备型号、设备硬件状态信息、IP 地址、Wifi状态、Wi-Fi SSID、操作系统版本、网络类型）、存储、网络权限
使用目的：即时文字通讯
隐私协议地址：<a href="https://cloud.tencent.com/document/product/269/58094">https://cloud.tencent.com/document/product/269/58094</a>
包名：com.tencent.imsdk

<span style="font-weight:bold;">10.uinMPsdk</span>
信息获取:获取运行中进程信息、获取IMEI	
使用:uni小程序SDK，是为原生App打造的可运行基于 uni-app 开发的小程序前端项目的框架，从而帮助原生App快速获取小程序的能力
SDK厂家:DCloud 数字天堂（北京）网络技术有限公司
https://nativesupport.dcloud.net.cn/

<span style="font-weight:bold;">11.Flutter SDK</span>
信息获取:设备信息（设备型号、设备硬件状态信息、Android_ID、IMEI、IP地址、MAC地址、Wifi状态、Wi-Fi SSID、硬件序列号、操作系统版本、网络类型）、存储、网络权限
使用目的:Flutter是Google的UI工具包，可通过单个代码库为移动，网络和桌面构建漂亮的，本机编译的应用程序
https://flutter.dev/showcase
包名：io.flutter

<span style="font-weight:bold;">12.阿里云播放器SDK</span>
本应用集成阿里云播放器SDK。当您在使用阿里云提供的视频服务时，我们会根据您授予的具体权限，接收并记录您所使用的设备信息，如：UUID、设备型号、IP地址、WIFI网络环境。我们还会收集您的日志信息，包括操作日志、服务日志。我们收集这些信息是为您音视频播放提供稳定、流畅、丰富的服务。如您拒绝提供可能导致无法使用我们的产品和服务。
阿里云视频服务隐私权政策链接：https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112151438_20307.html

<span style="font-weight:bold;">13.移动安全联盟OAID SDK</span>
信息获取：设备信息
使用目的：获取oaid
包名：com.bun.miitmdid、com.zui.opendeviceidlibrary、com.netease.nis、com.samsung.android、com.huawei.hms
隐私政策链接：http://www.msa-alliance.cn/col.jsp?id=122

<span style="font-weight:bold;">14.360加固服务</span>
信息获取：应用包信息、设备基础信息、Android ID
使用目的：用于检测App故障和诊断,App安全加固保护,盗版检测服务,威胁环境检测服务,以便帮助用户快速解决异常情况
包名：com.stub.StubApp
隐私政策链接：<a href="https://jiagu.360.cn/#/global/help/322">https://jiagu.360.cn/#/global/help/322</a>
 



（十一）其他 

1、若你提供的信息中含有其他用户的个人信息，在向亮健康提供这些个人信息之前，您需确保您已经取得合法的授权。若其中涉及儿童个人信息的，您需在发布前取得对应儿童监护人的同意，前述情形下监护人有权通过本政策第九条的途径联系我们，要求更正或删除涉及儿童个人信息的内容。 

2、若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。  若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们的专业安全团队对个人信息会进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制等）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。 

3、征得授权同意的例外  您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意，且我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：  

            （1）与国家安全、国防安全有关的；

            （2）与公共安全、公共卫生、重大公共利益有关的； 

            （3）与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的； 

            （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；

            （5）您自行向社会公众公开的个人信息； 

            （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。

            （7）根据与您签订和履行相关协议或其他书面文件所必需的； 

            （8）用于维护所提供的产品及/或服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障； 

            （9）为合法的新闻报道所必需的； 

            （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的； 

            （11）法律法规规定的其他情形。 请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善亮健康的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），则此类处理后数据的使用无需另行向您通知并征得您的同意。

4、如我们停止运营亮健康产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。涉及儿童个人信息的，我们会并将停止运营的通知及时告知儿童监护人。 

二、<span style="font-weight:bold;">我们如何使用Cookie和同类技术</span> 

（一）Cookie  为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储Cookie、Flash Cookie，或浏览器（或关联应用程序）提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（统称“Cookie”）。借助于Cookie，网站能够存储您的偏好或购物车内的商品等数据。  如果您的浏览器或浏览器附加服务允许，您可修改对Cookie的接受程度或拒绝我们的Cookie。有关详情，请参见AboutCookies.org。但如果您这么做，在某些情况下可能会影响您安全访问我们的网站，且可能需要在每一次访问我们的网站时更改用户设置。  

（二）Cookie同类技术  除Cookie外，我们还会在网站上使用网站信标、像素标签、ETag等其他同类技术。  例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好，以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。  ETag（实体标签）是在互联网浏览器与互联网服务器之间背后传送的HTTP协议标头，可代替Cookie。ETag可以帮助我们避免不必要的服务器负载，提高服务效率，节省资源、能源，同时，我们可能通过ETag来记录您的身份，以便我们可以更深入地了解和改善我们的产品或服务。大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。但请注意，如果停用ETag，您可能无法享受相对更佳的产品或服务体验。 

 三、<span style="font-weight:bold;">我们如何共享、转让、公开披露您的信息</span> 

 （一）共享  我们不会与亮健康服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：  

1、在法定情形下的共享：我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。

2、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。 

3、在您主动选择情况下共享：您通过亮健康平台购买商品或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易及售后服务需求。 

4、与关联公司间共享：为便于我们基于亮健康平台账户向您提供产品和服务，推荐您可能感兴趣的信息，识别会员账号异常，保护亮健康关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司和/或其指定的服务提供商共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。 

 5、与授权合作伙伴共享：我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。对于涉及儿童个人信息的，我们不允许合作伙伴进行转委托。  目前，我们的授权合作伙伴包括以下类型：  

（1）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息与提供广告、分析服务的合作伙伴共享。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。  

（2）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。  为了使您能够使用上述服务及功能，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序。如您使用华为/小米/魅族手机时，华为/小米/魅族Push SDK需要读取您的设备识别号、联网相关信息，用于推送/下发通知栏消息；如您使用向微博分享信息功能，相关SDK会收集您的设备识别号、联网相关信息；如您使用高德提供的地图服务，高德SDK需要您打开设备位置权限并收集设备所在位置、设备识别号、联网相关信息。  我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。 

 <span style="font-weight:bold;">（二）转让  我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外： </span>

1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；

2、在亮健康服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。 

<span style="font-weight:bold;">（三）公开披露  我们仅会在以下情况下，公开披露您的个人信息：</span>  

1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；

2、如果我们确定您出现违反法律法规或严重违反亮健康平台相关协议及规则的情况，或为保护亮健康平台用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及亮健康平台已对您采取的措施。例如，若您因出售假冒商品而严重违反亮健康平台规则，我们可能会公开披露您的店铺认证主体信息与违规情况。 

<span style="font-weight:bold;">（四）共享、转让、公开披露个人信息时事先征得授权同意的例外  以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</span> 

1、与国家安全、国防安全有关的； 

2、与公共安全、公共卫生、重大公共利益有关的；

3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的； 

4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的； 

5、您自行向社会公众公开的个人信息； 

6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。 请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。

四、<span style="font-weight:bold;">我们如何保护您的信息</span>  

（一）我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受SSL协议加密保护；我们同时对亮健康亮健康网站提供HTTPS协议安全浏览方式；我们会使用高维分布技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。 我们指定了专人负责儿童个人信息的保护，严格设定信息访问权限，对可能接触到儿童个人信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童个人信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。  

（二）我们有行业先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。目前，我们的重要信息系统已经通过网络安全等级保护的三级以上测评和ISO27001认证。  

（三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。而我们判断前述期限的标准包括：  

1、完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉； 

2、保证我们为您提供服务的安全和质量； 

3、您是否同意更长的留存期间； 

4、是否存在保留期限的其他特别约定。 在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。 

（四）互联网并非绝对安全的环境，使用亮健康平台服务时，我们强烈建议您不要使用非亮健康平台推荐的通信方式发送您的信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。  在使用亮健康服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络亮健康客服，以便我们根据您的申请采取相应措施。  请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。  请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。  

（五）我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过亮健康平台公告方式获得。  

（六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。  我们已制定儿童个人信息安全事件应急预案，定期组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。在不幸发生儿童个人信息安全事件后，我们将按照法律法规的要求，及时向儿童及其监护人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、儿童及其监护人可自主防范和降低风险的建议、对儿童及其监护人的补救措施等。我们将及时将事件相关情况以APP推送通知、发送邮件/短消息等方式告知儿童及其监护人。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童个人信息安全事件的处置情况。若儿童及其监护人的合法权益受损，我们将依法承担相应的法律责任。  同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。 

 <span style="font-weight:bold;">五、您如何管理您的信息 您可以通过以下方式访问及管理您的信息：</span>   

（一）查询、更正和补充您的信息  您有权查询、更正或补充您的信息。您可以通过以下方式自行进行：  

1、登录手机亮健康客户端，进入“我的->点击头像昵称”对个人资料等信息进行查询、更正或补充； 

2、登录亮健康并选择联系客服，或登录手机亮健康客户端并选择“我的亮健康联系客服（7*24小时）寻求帮助，协助您查询、更正或补充您的信息。 
（二）删除您的信息  您可以通过“（一）查询、更正和补充您的信息”中列明的方式删除您的部分信息。  在以下情形中，您可以向我们提出删除个人信息的请求：  

1、如果我们处理个人信息的行为违反法律法规；

2、如果我们收集、使用您的个人信息，却未征得您的明确同意； 

3、如果我们处理个人信息的行为严重违反了与您的约定；

4、如果您不再使用我们的产品或服务，或您主动注销了账号；

5、如果我们永久不再为您提供产品或服务。 若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。  当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。  

（三）改变您授权同意的范围  每个业务功能需要一些基本的个人信息才能得以完成（见本隐私权政策“第一部分”）。您可以在手机亮健康APP“我的-设置-隐私协议”中,收回您通过手机号码找到我的用户同意授权  当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。 

（四）<span style="font-weight:bold;">注销您的账户  您可以通过以下方式申请注销您的账户：</span>  

1、登录手机亮健康客户端，通过“我的-设置-账号与安全-账号安全-注销账号”提交账户注销申请；  

2、登录亮健康并选择联系客服，或登录手机亮健康客户端并选择“我的亮健康-联系客服（7*24小时）寻求帮助，协助您申请注销您的账户。  在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。  

（五）约束信息系统自动决策  在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害亮健康商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。  

（六）响应您的上述请求  为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。  我们将在15天内做出答复。如您不满意，还可以通过亮健康客服发起投诉。  对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无端重复信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。  在以下情形中，按照法律法规要求，我们将无法响应您的请求： 

1、与国家安全、国防安全有关的； 

2、与公共安全、公共卫生、重大公共利益有关的； 

3、与犯罪侦查、起诉、审判和执行判决等有关的； 

4、有充分证据表明个人信息主体存在主观恶意或滥用权利的； 

5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的； 

6、涉及商业秘密的。

<span style="font-weight:bold;">（七）关闭个性化推荐</span>
如果您不希望接收我们向您推送的精准营销信息，您可以根据以下步骤关闭个性化推荐：
 1)App首页后需要点击进入“我的”页面；
 2) 点击“设置”
 3) 点击“个性化推荐”；

六、我们如何处理未成年人的信息 在电子商务活动中我们推定您具有相应的民事行为能力。如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本隐私权政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。  如果我们识别出您是儿童用户的，我们将通知您的监护人并要求您的监护人同意儿童个人信息收集使用规则。对于经父母或其他监护人同意使用我们的产品或服务而收集儿童个人信息的情况，我们只会在法律法规允许、父母或其他监护人明确同意或者保护儿童所必要的情况下使用、共享、转让或披露此信息。  若您是儿童的父母或其他监护人，请您关注您监护的儿童是否是在取得您的授权同意之后使用我们的服务的。如您对您所监护的儿童的个人信息有疑问，请通过第九节中的联系方式与我们联系。  

<span style="font-weight:bold;">七、您的信息如何在全球范围转移 我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外： </span>

1、适用的法律有明确规定；

 2、获得您的明确授权；

3、您通过互联网进行跨境交易等个人主动行为。 针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。 

<span style="font-weight:bold;">八、本隐私权政策如何更新 我们的隐私权政策可能变更。</span>  未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在专门页面上发布对隐私权政策所做的任何变更。  对于重大变更，我们还会提供更为显著的通知（包括我们会通过亮健康公示的方式进行通知甚至向您提供弹窗提示）。  本政策所指的重大变更包括但不限于：  

1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等； 

2、我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等； 

3、个人信息共享、转让或公开披露的主要对象发生变化； 

4、您参与个人信息处理方面的权利及其行使方式发生重大变化； 

5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；

6、个人信息安全影响评估报告表明存在高风险。 

九、如何联系我们 您可以通过以下方式与我们联系，我们将在15天内回复您的请求：  

1、如对本政策内容、儿童个人信息有任何疑问、意见或建议，您可通过亮健康在线客服与我们联系；

2、如发现个人信息可能被泄露，您可以通过在线客服投诉举报； 

3、您可以通过其他方式与其联系。 

注册地址：湖南省长沙市芙蓉区定王台街道芙蓉中路二段88号定王大厦201  

常用办公地址:湖南省长沙市芙蓉区定王台街道芙蓉中路二段88号定王大厦201  

信息保护负责人联系电话0731-82578852  如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。

注：本隐私政策版本更新日期为2021年【9】月【30】日，将于2021年【9】月【30】日正式生效。
`;
